import React from 'react';
import { MDBRow, MDBCol, MDBIcon } from 'mdbreact';
import Header from './ComponentFragments/Header';
import PotentialTeamLeaderCards from './ComponentFragments/PotentialTeamLeaderCards';
import Datalayer from '../Utilities/DataLayer';
import Colors from '../Styles/Colors'

export default class PotentialTeamLeader extends React.Component {
    constructor(props) {
        super();
        this.state = {
            PotentialTeamLeaders: [],
            PromoteOuts: [],
            ShowPromoteOuts: false
        }

        this.dataLayer = new Datalayer();
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));

        this.loadPotentialTeamLeaders = this.loadPotentialTeamLeaders.bind(this);
        this.loadPromoteOuts = this.loadPromoteOuts.bind(this);
    }

    componentWillMount() {
        this.loadPotentialTeamLeaders();
    }

    async loadPotentialTeamLeaders() {
        this.props.loaderOn();
        let response = await this.dataLayer.Get('/common/GetPotentialTeamLeaders');
        this.props.loaderOff();
        this.setState({ PotentialTeamLeaders: response.data });
        console.log(response.data);
    }

    async loadPromoteOuts(type) {
        this.props.loaderOn();
        let PromoteOuts = this.state.PotentialTeamLeaders.filter((manager) => manager.mainManager == false && manager.type == type);

        this.setState({ PromoteOuts: PromoteOuts, ShowPromoteOuts: true });
        this.props.loaderOff();
    }

    render() {
        let potentialTeamLeads = this.state.PotentialTeamLeaders.filter((manager) => manager.mainManager == true);

        return (
            <div>
                {
                    (this.state.ShowPromoteOuts) ?
                        (
                            <div>
                                <Header headerText="Potential Team Leader P/O's" hideSearch={true} />
                                <MDBRow>
                                    {
                                        this.state.PromoteOuts.map((manager) => {
                                            return (
                                                <MDBCol xl="4" lg="6" md="6" sm="12">
                                                    <PotentialTeamLeaderCards manager={manager} hideButton={true} loaderOff={this.props.loaderOff} />
                                                </MDBCol>
                                            )
                                        })
                                    }
                                </MDBRow>
                            </div>
                        ) : (
                            <div>
                                <Header headerText="Potential Team Leaders" hideSearch={true} />
                                <MDBRow>
                                    {
                                        potentialTeamLeads.map((manager) => {
                                            return (
                                                <MDBCol xl="4" lg="6" md="6" sm="12">
                                                    <PotentialTeamLeaderCards manager={manager} loadPromoteOuts={this.loadPromoteOuts} loaderOff={this.props.loaderOff} />
                                                </MDBCol>
                                            )
                                        })
                                    }
                                </MDBRow>
                            </div>
                        )
                }

            </div>
        );
    }
}